import { config } from 'config';
import tagManager from 'react-gtm-module';

export const configureGTM = (): void => {
    tagManager.initialize(config.tagManager);
};
